import Vue from 'vue'
export var effect_list=['隐藏','显示'];
export function hasBtn(btnName)
{
    let btn = JSON.parse(sessionStorage.getItem('btnList'))||[];
    if (btn.length==0){
        return null
    }else {
        var link=[];
        btn.forEach(function(e,i) {
            link[i]=e.link;
        });
        return link.indexOf(btnName) > -1;
    }
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function expiry_time(data) {
    if (parseFloat(data.stock_quantity)==0) {
        return '';
    }
    var date_array = data.expiry_time.split('-');
    var t = new Date(date_array[0],date_array[1]-1,date_array[2],23,59,59).getTime();
    var ts = new Date().getTime();
    if (ts>t) {
        return 'color';
    }
    return '';

}
export function api_imgurl(value) {
    var API_IMGURL = process.env.API_IMGURL;
    return API_IMGURL+value;
}
export function router_url(url,query) {
    var date = new Date().getTime();
    var query_obj={
        t:date
    };
    if (query) {
        query['t']=date;
    }else{
        query=query_obj
    }
    console.log(this.$router)
    this.$router.push({
        path: url,
        query:query
    });
}
export function getTime(/** timestamp=0 **/) {  
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='HH:mm:ss'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s)
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}

// 打印出库单
export function parts(data,height,resolve){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小

        LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
        LODOP.ADD_PRINT_IMAGE(0,5,800,height,"<img src='"+data+"'>");


       
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
        if (resolve) {
            resolve();
        }
    }
}

/**
 * 获取屏幕高度
 * @param {number} height 要减去的高度
 * @return {number}
 */
export function screenHeight(height = 0) {
    var deduct=50+20+50+47+66;
    var defaultHeight = 880
    var winHeight;
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
    }
    console.log(winHeight)
    if (winHeight) {
        return winHeight - height - deduct
    } else {
        return defaultHeight - height - deduct
    }
}
export function secondsToMinutesAndHours(seconds) {
    let minutes = Math.floor(seconds / 60); // 获取完整的分钟数
    let hours = Math.floor(minutes / 60); // 获取完整的小时数，先转换为分钟再除以60得到小时数
    minutes = minutes % 60; // 获取剩余的分钟数，即一小时内的分钟数
    var second = Math.floor(seconds % 60);
    var current_time = '';
    if(hours>0){
        current_time+=(hours>9?hours:'0'+hours)+':';
    }
    current_time+=(minutes>9?minutes:'0'+minutes)+':'+(second>9?second:'0'+second);
    return current_time;
}


//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 